export { default } from './recentSearch';
